import { useEffect, useState } from "react";
import { auth } from "../auth";
import { tokens as tokenAPI } from "../tokens";
export const useIsAuthenticated = () => {
    const tokens = tokenAPI.get();
    const [hookState, setHookState] = useState({
        loading: true,
        authenticated: false,
    });
    useEffect(() => {
        (async () => {
            setHookState({ loading: true, authenticated: false });
            const result = await auth.isAuthenticated;
            setHookState({ loading: false, authenticated: result !== false });
        })();
    }, [tokens.token]);
    if (!tokens.token && tokens.refreshToken)
        return [true, false];
    return [hookState.loading, hookState.authenticated];
};
